import RichText from '@/components/RichText';
import { formatDate, formatText } from '@/helpers/functions';
import { TextComponentType } from '@/types/atoms';
import classNames from 'classnames';

type TextType = {
  textComponent: TextComponentType;
  layout: 1 | 2;
  className?: string;
};

const Text = ({ textComponent, className, layout }: TextType) => {
  const { heading, options, text, list } = textComponent;

  const layoutClass: Record<typeof layout, string[]> = {
    1: ['grid-cols-4'],
    2: ['lg:grid-cols-8'],
  };

  return (
    <div className={classNames(className, 'flex flex-col gap-y-4 lg:ap-y-6')}>
      {heading && <h3 className="text-md">{heading}</h3>}

      <div className="text-content flex flex-col col-span-full row-start-2 gap-y-10">
        {options.addText && text && (
          <RichText
            className={classNames(
              'gap-x-6 grid [&_p]:col-span-4',
              layoutClass[layout]
            )}
            text={text}
          />
        )}
        {options.addList && (
          <ul className="text-base h-fit grid grid-cols-[auto_1fr]">
            {list?.map((li) => (
              <li
                key={li._key}
                className="grid grid-cols-[inherit] col-span-2 gap-2 border-t py-3 lg:py-4"
              >
                <span className="w-[117px]">{li.title}</span>
                {li.type === 'text' && li.text && (
                  <span>{formatText(li.text)}</span>
                )}
                {li.type === 'date' && li.date && (
                  <span className="capitalize">
                    {formatDate(li.date, 'long')}
                  </span>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
export default Text;
